import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layoutOneActiving",
  "use": "icon-layoutOneActiving-usage",
  "viewBox": "0 0 1057 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1057 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-layoutOneActiving\"><path d=\"M132.129032 928.008258a66.064516 66.064516 0 0 1-66.064516-66.064516v-59.854452a66.064516 66.064516 0 0 1 66.064516-66.064516h792.774194a66.064516 66.064516 0 0 1 66.064516 66.064516v59.854452a66.064516 66.064516 0 0 1-66.064516 66.064516z m0-319.950452a66.064516 66.064516 0 0 1-66.064516-66.064516v-59.920516a66.064516 66.064516 0 0 1 66.064516-66.064516h792.774194a66.064516 66.064516 0 0 1 66.064516 66.064516v59.854452a66.064516 66.064516 0 0 1-66.064516 66.064516zM132.129032 288.04129a66.064516 66.064516 0 0 1-66.064516-66.064516v-59.920516a66.064516 66.064516 0 0 1 66.064516-66.064516h792.774194a66.064516 66.064516 0 0 1 66.064516 66.064516v59.788387a66.064516 66.064516 0 0 1-66.064516 66.064516z\" p-id=\"12133\" fill=\"#2c6bb8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/layoutOneActiving.svg
// module id = BB80
// module chunks = 55